module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("客户名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.customerName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("客户经理")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.followupStaffName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("合同名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.name))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("合同类型")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.contractTypeName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("合同编号（内部编号）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.contractNo))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("委托编号（外部编号）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.entrustNo))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("合同金额（元）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.contractPrice))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("是否补充合同")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.isAdditional))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("是否历史合同")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.isHistory))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("合同有效期（合同服务期）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.contractDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("签订部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.departmentName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("签订日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.signDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("付款信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("付款方")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payUnitName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payType))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("履约保证金信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("是否缴纳履约保证金")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.isJNLYBZJ))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("履约保证金金额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.LYBZJ))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("履约保证金形式")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.LYBZJXS))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("是否退回")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.isBackBZJ))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("收款信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("记账单位")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.faccountUnit))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("收款账号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.faccountNo))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name detail-page-remark",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("备注")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.info.remark))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73dcde3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/contract/collection.vue
// module id = a8JX
// module chunks = 1